export const pricingData = {
  data: {
    affiliateId: 77,
    affiliatePricing: [
      {
        productId: 1,
        productDescription: 'standardWindows',
        productPricing: [
          {
            minQty: 4,
            maxQty: 7,
            minPrice: 2667,
            maxPrice: 6553,
          },
          {
            minQty: 1,
            maxQty: 3,
            minPrice: 3025,
            maxPrice: 7653,
          },
          {
            minQty: 8,
            maxQty: 1000,
            minPrice: 2200,
            maxPrice: 5200,
          },
        ],
      },
      {
        productId: 2,
        productDescription: 'coastal',
        productPricing: [
          {
            minQty: 4,
            maxQty: 7,
            minPrice: 2667,
            maxPrice: 6553,
          },
          {
            minQty: 1,
            maxQty: 3,
            minPrice: 3025,
            maxPrice: 7653,
          },
          {
            minQty: 8,
            maxQty: 1000,
            minPrice: 2200,
            maxPrice: 5200,
          },
        ],
      },
      {
        productId: 4,
        productDescription: 'patioDoors',
        productPricing: [
          {
            minQty: 1,
            maxQty: 1,
            minPrice: 2668,
            maxPrice: 6554,
          },
          {
            minQty: 2,
            maxQty: 1000,
            minPrice: 3025,
            maxPrice: 7653,
          },
        ],
      },
      {
        productId: 3,
        productDescription: 'entryDoors',
        productPricing: [
          {
            minQty: 1,
            maxQty: 1,
            minPrice: 2667,
            maxPrice: 6553,
          },
          {
            minQty: 2,
            maxQty: 1000,
            minPrice: 3025,
            maxPrice: 7653,
          },
        ],
      },
    ],
  },
};

export const summaryLineItems = [
  {
    label: 'Windows',
    min: 4000,
    max: 7000,
    lineItems: [
      { label: 'Standard', min: 1000, max: 2000 },
      { label: 'Coastal', min: 3000, max: 5000 },
    ],
  },
  {
    label: 'Patio Doors',
    min: 500,
    max: 1000,
    lineItems: [{ label: 'Patio Door', min: 500, max: 1000 }],
  },
  { label: 'Total Estimate', min: 0, max: 0 },
];
